import { FILE_EXTENSION, MEDIA_TYPE } from './media'

export const DEFAULT_IFRAME_WIDTH = 560
export const DEFAULT_IFRAME_HEIGHT = 315
export const MEDIA_EXTENSIONS = {
  [MEDIA_TYPE.IMAGE]: [FILE_EXTENSION.JPEG, FILE_EXTENSION.JPG],
  [MEDIA_TYPE.VIDEO]: [FILE_EXTENSION.MP4],
  [MEDIA_TYPE.PDF]: [FILE_EXTENSION.PDF],
  [MEDIA_TYPE.MS_WORD]: [FILE_EXTENSION.DOC, FILE_EXTENSION.DOCX],
  [MEDIA_TYPE.MS_EXCEL]: [FILE_EXTENSION.XLS, FILE_EXTENSION.XLSX],
  [MEDIA_TYPE.UNKNOWN]: ['']
}
